module.exports = __webpack_public_path__ + "media/icons/widget-logo@2x-ef78ccd9.png";